import { useEffect, useMemo, useState } from 'react';
import { useQueryParams } from '@/hooks';
import { ServiceHistoryFilter } from '../models';

const useServiceHistoryFilter = () => {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: ServiceHistoryFilter = useMemo(() => {
    const today = new Date();
    const dateFrom = new Date(today.getFullYear(), today.getMonth(), 1);
    const dateTo = new Date();
    
    return {
      dateFrom,
      dateTo,
      barcode: '',
    };
  }, []);

  const [filter, setFilter] = useState<ServiceHistoryFilter>(() => {
    const dateFrom = getQueryParam('dateFrom') || '';
    const dateTo = getQueryParam('dateTo') || '';

    return {
      dateFrom: dateFrom ? new Date(dateFrom) : initialFilter.dateFrom,
      dateTo: dateTo ? new Date(dateTo) : initialFilter.dateTo,
      barcode: getQueryParam('barcode') || initialFilter.barcode,
    };
  });

  useEffect(() => {
    setQueryParams({
      dateFrom: filter.dateFrom?.toISOString(),
      dateTo: filter.dateTo?.toISOString(),
      barcode: filter.barcode,
    });
  }, [filter]);

  return {
    initialFilter,
    filter,
    setFilter,
  };
};

export default useServiceHistoryFilter;
